import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Clear authentication
    localStorage.removeItem("isAuthenticated"); // removes the item

    // Or if you want to just set it false:
    // localStorage.setItem("isAuthenticated", "false");

    // Redirect to login
    navigate("/login", { replace: true });
  }, [navigate]);

  return null; // No UI needed
};

export default Logout;
